// Şifre gücü — zxcvbn wrapper. §4.1.3 design ref: 0-4 score + renk + etiket.
// Ek olarak 4 kural listesi (§4.1.3 gereksinim panel) tutarlı göstergeler.

import zxcvbn from "zxcvbn";

export interface PasswordRules {
  minLength: boolean; // 12+ (backend min: 12, plan §4.1.3)
  hasUpper: boolean;
  hasDigit: boolean;
  hasSpecial: boolean;
}

export interface PasswordStrength {
  score: 0 | 1 | 2 | 3 | 4;
  label: string;
  barPercent: number;
  color: string;
  rules: PasswordRules;
  feedback: string | null;
}

const SCORE_LABELS: Record<number, string> = {
  0: "Çok zayıf",
  1: "Zayıf",
  2: "Orta",
  3: "İyi",
  4: "Güçlü",
};

const SCORE_COLORS: Record<number, string> = {
  0: "var(--color-error)",
  1: "var(--color-error)",
  2: "var(--color-warning)",
  3: "var(--color-success)",
  4: "var(--color-success)",
};

export function evaluatePassword(password: string): PasswordStrength {
  const rules: PasswordRules = {
    minLength: password.length >= 12,
    hasUpper: /[A-ZÇĞIİÖŞÜ]/.test(password),
    hasDigit: /[0-9]/.test(password),
    hasSpecial: /[^A-Za-z0-9ÇĞIİÖŞÜçğıiöşü]/.test(password),
  };

  if (password.length === 0) {
    return {
      score: 0,
      label: "",
      barPercent: 0,
      color: SCORE_COLORS[0]!,
      rules,
      feedback: null,
    };
  }

  const res = zxcvbn(password);
  const score = res.score;
  // zxcvbn empty string kullanıyor → null'a normalize et
  const warning = res.feedback.warning.length > 0 ? res.feedback.warning : null;
  const firstSuggestion = res.feedback.suggestions[0];
  const suggestion =
    firstSuggestion !== undefined && firstSuggestion.length > 0 ? firstSuggestion : null;

  return {
    score,
    label: SCORE_LABELS[score]!,
    barPercent: (score + 1) * 20,
    color: SCORE_COLORS[score]!,
    rules,
    feedback: warning ?? suggestion,
  };
}

export function rulesAllPass(rules: PasswordRules): boolean {
  return rules.minLength && rules.hasUpper && rules.hasDigit;
}
